<template>
  <div>
    <b-modal
      id="modal_provider"
      ref="modal_cate"
      modal-class="modal modal_provider items_4 fade"
      :no-close-on-backdrop="false"
      :no-close-on-esc="true"
      dialog-class="modal-dialog modal-dialog-centered"
      :header-class="['modal-header justify-content-center align-items-center border-bottom-0', $store.getters.brand.theme]"
      body-class="text-center"
      hide-footer
    >
      <template v-slot:modal-header>
        <button
          type="button"
          class="close rounded-circle m-0"
          data-dismiss="modal"
          aria-label="Close"
          @click="hideModal"
        >
          <i class="icon-clear" />
        </button>
      </template>
      <template v-if="selectedGameTypeId === 0">
        <ul id="providerCategory" class="modal_provider_list flex-wrap list-unstyled mb-0">
          <li v-for="(type, key) in gameType" :key="key" class="provider_item_list" role="button" @click="selectGameType(type)">
            <div class="provider_item_img">
              <img class="mw-100" :src="type.image_pc_icon" alt="">
            </div>
            <p class="provider_item_txt">
              {{ type.name }}
            </p>
          </li>
        </ul>
      </template>
      <template v-else>
        <div id="modalArrowBack" class="arrow_back" role="button" style="display: block;" @click="goBack()">
          <div class="arrow-back-img">
            <img src="@/assets/img/provider/arrow_back.svg" alt="">
          </div>
          <p class="cate_txt">
            {{ selectedGameTypeName }}
          </p>
        </div>
        <ul class="modal_provider_container">
          <li v-for="(item, key) in providers" :key="key" class="modal_provider_item" @click="handleProviderLink(item)">
            <div class="modal_provider_content">
              <img :src="item.image" alt="">
            </div>
          </li>
        </ul>
        <div v-if="providers.length === 0">
          <br><br><br><br><br><br><br><br><br>
        </div>
      </template>
      <template v-slot:modal-footer />
    </b-modal>
  </div>
</template>

<script>
import { providerLink } from '@/utils/games'

export default {
  data() {
    return {
      selectedGameTypeId: 0,
      selectedGameTypeName: '',
      providers: []
    }
  },
  computed: {
    gameType() {
      return this.$store.state.game.gameType
    }
  },
  watch: {
    '$store.state.game.gameType': function(to, from) {
      if (to === undefined) return
      this.getProviders()
    }
  },
  mounted() {
    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      if (modalId === 'modal_provider') {
        this.selectedGameTypeId = 0
      }
    })
  },
  methods: {
    clickSwitch() {
    },
    goBack() {
      this.selectedGameTypeId = 0
    },
    selectGameType(gameType) {
      this.selectedGameTypeId = gameType.id
      this.selectedGameTypeName = gameType.name
      this.getProviders()
    },
    getProviders() {
      this.providers = []
      for (const i in this.gameType) {
        if (this.gameType[i].id === this.selectedGameTypeId) {
          for (const j in this.gameType[i].providers) {
            this.providers.push(this.gameType[i].providers[j])
          }
        }
      }
    },
    handleProviderLink(provider) {
      if (!this.$store.getters.token) {
        this.$bvModal.show('modal_login_box')
      } else {
        providerLink(provider)
        this.hideModal()
      }
    },
    hideModal() {
      this.$bvModal.hide('modal_provider')
    }
  }
}
</script>

